import { PageProps } from '@react-pdf/renderer'

import { BalanceSheetReportOptions } from '../../../../../types/reportOptions'

const COMPARE_COUNT = 2

export const getBalanceSheetPageOrientation = (filters: BalanceSheetReportOptions): PageProps['orientation'] => {
  const hasMultipleComparisons = (filters?.compareCount || 0) > COMPARE_COUNT

  return hasMultipleComparisons ? 'landscape' : 'portrait'
}
